import { render, staticRenderFns } from "./my-tree.vue?vue&type=template&id=51c1e520&scoped=true&"
import script from "./my-tree.vue?vue&type=script&lang=js&"
export * from "./my-tree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c1e520",
  null
  
)

export default component.exports